import React from 'react';
import { Button } from 'reactstrap';
// import { Modal, ModalHeader, Button } from 'reactstrap';
// import { Form, useFormValidator } from '@sharingapples/form';
// import { FormSubmitButton, Validators } from '@dom/components';
// import differenceInDays from 'date-fns/difference_in_calendar_days'; 

// import { BookingNotAvailableModal } from '../../components/MessageModals';
// import { GuideSearchInput, GuideBookingDates } from '../../components/GuideSearchFormElements';

// import { isBookingDateValid } from '../../utils';
// import { updateGuideSearchQuery } from '../../redux/actors';

import './CheckAvailabilityForm.scss';

// const defaultValues = {
//   pax: 1,
// };

export default function CheckAvailabilityModal() {
  // const [isOpen, setIsOpen] = useState(false);
  // const open = () => setIsOpen(true);
  // const toggle = () => setIsOpen(!isOpen);

  // const [isMessageModalVisible, setModalVisibility] = useState(null);
  // const closeMessage = () => setModalVisibility(false);
  // const openMessage = () => setModalVisibility(true);

  // const handleSubmit = state => {
  //   const { startDate, endDate } = state;
  //   if(isBookingDateValid(startDate)) {
  //     const numberOfDays = differenceInDays(endDate, startDate) + 1;
  //     updateGuideSearchQuery({...state, numberOfDays});
  //     return setIsOpen(false);
  //   } else {
  //     openMessage();
  //   }
  // };

  const scrollToForm = () => {
    const form = document.getElementById('modify-selection-form');
    form && form.scrollIntoView();
  }

  return (
    <>
      {/* <BookingNotAvailableModal isOpen={isMessageModalVisible} close={closeMessage}/> */}
      <Button color="yellow" onClick={scrollToForm} >Check Availability</Button>
      {/* <Modal isOpen={isOpen} toggle={toggle} className="check-availability">
        <ModalHeader toggle={toggle}>Check Availability</ModalHeader>
          <Form onSubmit={handleSubmit} defaultValue={defaultValues}>
            <CheckAvailabilityForm/>
          </Form>
      </Modal> */}
    </>
  )
};

// const CheckAvailabilityForm = () => {

//   const dateError = useFormValidator('startDate', Validators.required('Please inform us your booking dates.'));
//   const textError = useFormValidator('guideQuery', Validators.required('Please tell us where you want to trek.'));

//   return (
//     <>
//         <section className="select__date">
//           <div className="select__date_checkin_checkout">
//             <GuideSearchInput parentError={textError} />
//           </div>
//           <div className="select__date_guest">
//             <GuideBookingDates parentError={dateError} />
//           </div>
//           <div className="select__date_action">
//             <FormSubmitButton buttonText="Submit"/>
//           </div>
//         </section>
//     </>
//   )
// }
